var render = function render(){var _vm=this,_c=_vm._self._c;return _c('dash-button',{staticClass:"dash-toggle-button",attrs:{"disabled":_vm.disabled,"suffix":_vm.icon},on:{"click":_vm.changeValue},scopedSlots:_vm._u([{key:"label",fn:function(){return [_c('span',{staticClass:"label",class:{ selected: _vm.value, disabled: _vm.disabled }},[_vm._v(" "+_vm._s(_vm.label)+" ")])]},proxy:true}])})
}
var staticRenderFns = []

export { render, staticRenderFns }